// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrors = {
  apiCodeUnknown: "エラーコード {code} のリクエスト失敗です",
} as const;
